import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';

import { PromoCodesClient } from '@/components/admin/promo-codes-client';
import { PageHeader } from '@/components/dashboard/page-header';

export const Route = createFileRoute('/_admin/admin/promos')({
  component: PromosPage,
});

function PromosPage(): React.ReactElement {
  return (
    <div className="mx-auto flex w-full max-w-7xl flex-col gap-6">
      <PageHeader
        title="Codes promo"
        subtitle="Créez un code, choisissez qui peut l’utiliser et envoyez-le par email."
      />
      <PromoCodesClient />
    </div>
  );
}
